import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const LocationShadowGlyph = /*#__PURE__*/createElement("g", {
  id: "location_w_shadow"
}, /*#__PURE__*/createElement("path", {
  d: "M42,45.35a11.1,11.1,0,1,1,11.1-11.1A11.11,11.11,0,0,1,42,45.35Zm0-19.2a8.1,8.1,0,1,0,8.1,8.1A8.1,8.1,0,0,0,42,26.15Z",
  transform: "translate(-11.61 -14.04)"
}), /*#__PURE__*/createElement("path", {
  d: "M42,60.64a1.51,1.51,0,0,1-1.06-.44L30.53,49.78l0,0c-2-1.9-8.11-8.37-8.11-15.85a19.62,19.62,0,0,1,39.24,0c0,8.08-6.07,14.34-8.15,15.89L43.06,60.2A1.51,1.51,0,0,1,42,60.64Zm-9.35-13L42,57l9.35-9.36a2,2,0,0,1,.29-.22c.5-.4,7-5.86,7-13.54a16.62,16.62,0,0,0-33.24,0c0,6.32,5.47,12.05,7.15,13.65l.11.12Z",
  transform: "translate(-11.61 -14.04)"
}), /*#__PURE__*/createElement("ellipse", {
  cx: "30.39",
  cy: "52.67",
  rx: "22.23",
  ry: "3.13"
}));
const LocationShadow = createSvg({
  name: 'location_shadow',
  path: LocationShadowGlyph
});

export default LocationShadow;
export { LocationShadowGlyph };
